import { useState } from "react";

import { Icon } from "@blueprintjs/core";
import { Headset } from "lucide-react";

import { Container } from "@/components/pieces/bootstrap";
import { Button } from "@/components/ui/button";
import { FullRoleplaySession } from "@/types/roleplays";

import AICoachCall from "./AICoachCall";

interface AICoachBarProps {
  roleplaySession: FullRoleplaySession;
  disabled?: boolean;
}

export function AICoachBar({ roleplaySession }: AICoachBarProps) {
  const [isCallActive, setIsCallActive] = useState(false);

  const handleStartCall = () => {
    setIsCallActive(true);
  };

  const handleEndCall = () => {
    setIsCallActive(false);
  };

  return (
    <div
      className={`group md:ml-sidebar py-3 border-t-1 border-blue-700 fixed bottom-0 left-0 right-0 bg-white shadow-lg z-50 transition-all duration-300 ${
        !isCallActive ? "cursor-pointer hover:bg-[#EEF6FF]" : ""
      }`}
      onClick={!isCallActive ? handleStartCall : undefined}
    >
      <Container>
        {isCallActive ? (
          <AICoachCall
            roleplaySession={roleplaySession}
            onEndCall={handleEndCall}
          />
        ) : (
          <div className="flex items-center justify-between h-full md:px-6">
            <div className="flex items-center gap-2 md:gap-3">
              <div
                className="w-7 h-7 transition-all duration-200 rounded-full bg-blue-200 group-hover:bg-blue-700  flex items-center justify-center flex-shrink-0
                text-blue-700 group-hover:text-white"
              >
                <Headset size={14} color="currentColor" />
              </div>
              <div>
                <div className="font-semibold transition-all duration-200 text-gray-800 text-sm group-hover:text-blue-700">
                  <span className="md:hidden">AI Coach Feedback</span>
                  <span className="hidden md:inline">
                    Talk through feedback with an AI Coach
                  </span>
                </div>
              </div>
            </div>
            <div className="opacity-100 md:opacity-0 md:group-hover:opacity-100 transition-opacity duration-200">
              <Button size="sm" variant="minimal">
                <Icon icon="phone" color="currentColor" size={14} />
                Start Call
              </Button>
            </div>
          </div>
        )}
      </Container>
    </div>
  );
}
